var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_652_16425)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 30.3775C23.2615 30.3775 30 23.639 30 15.3775C30 7.11596 23.2615 0.377502 15 0.377502C6.73846 0.377502 0 7.11596 0 15.3775C0 23.639 6.73846 30.3775 15 30.3775Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39949 12.4745H10.722V22.0281C10.628 22.4958 10.1956 22.846 9.70691 22.846H7.39949C6.83998 22.846 6.38477 22.3904 6.38477 21.8309V13.4892C6.38477 12.9298 6.83998 12.4745 7.39949 12.4745ZM23.1988 13.5864C22.6799 12.9212 21.747 12.4746 20.8775 12.4746H15.9832C15.9448 12.4745 15.9069 12.4656 15.8725 12.4485C15.8381 12.4314 15.8082 12.4066 15.785 12.3759C15.7616 12.3453 15.7457 12.3097 15.7385 12.2719C15.7313 12.2341 15.7329 12.1951 15.7433 12.1581L16.3619 9.93961C16.9573 7.8048 16.1714 7.20896 14.3645 6.44021C14.1954 6.36832 14.031 6.36727 13.8612 6.43664C13.6915 6.50566 13.575 6.62139 13.5046 6.79078L11.2203 12.2748V21.8868L13.522 22.846H19.6175C21.4203 22.846 22.0951 20.9315 22.3015 20.1086L23.5618 15.0901C23.7248 14.4406 23.4544 13.9138 23.1988 13.5864Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_652_16425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.377441)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.433afe613b1fbeebe5bdec909fb727db.svg";
export { ForwardRef as ReactComponent };